import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { DataTestIds } from "data-test-constants";
import LegalPersonViewModel from "viewModels/notice/components/operator/legalPersonViewModel";
import { Col, Form } from "react-bootstrap";
import { Input } from "@frui.ts/bootstrap";
import { registerView } from "@frui.ts/views";

const LegalPersonView: FunctionComponent<{
  vm: LegalPersonViewModel;
}> = observer(
  ({ vm }) =>
    vm.person && (
      <>
        <Form.Row>
          <Form.Group controlId="company-name" as={Col} sm={12} xl={6}>
            <Form.Label>{vm.translateAttribute("organization", "name")}</Form.Label>
            <Input target={vm.person} property="companyName" data-testid={DataTestIds.COMPANY_NAME_INPUT} />
          </Form.Group>
          <Form.Group controlId="company-identifier" as={Col} sm={12} xl={6}>
            <Form.Label>{vm.translateAttribute("organization", "organizationIdentifier")}</Form.Label>
            <Input target={vm.person} property="companyRegistrationNumber" data-testid={DataTestIds.COMPANY_IDENTIFIER_INPUT} />
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group controlId="organization-address-input" as={Col} sm={12}>
            <Form.Label>{vm.translateAttribute("address", "organizationTitle")}</Form.Label>
            <Input as="textarea" target={vm.person} property={"companyAddress"} />
          </Form.Group>
        </Form.Row>
      </>
    )
);

registerView(LegalPersonView, LegalPersonViewModel);
